import Vue from "@/main";
import proj4 from "proj4";

export let tileSetPlanClip_list = [];
let currentModelId;
let tilesetBoxClip;
export let graphicLayer; // 矢量图层对象

export function Initialization() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  Vue.$GLOBAL.map.addLayer(graphicLayer);
}

export function create_model_layer(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  let tileSetPlanClip = new mars3d.thing.TilesetPlanClip({
    positions: [],
    layer: tilesetLayer,
    clipOutSide: false,
    edgeColor: Cesium.Color.GREY,
    edgeWidth: 2.0,
  });
  Vue.$GLOBAL.map.addThing(tileSetPlanClip);
  tileSetPlanClip_list.push(tileSetPlanClip);

  return tileSetPlanClip;
}

export function addPlanClipThing(tileSetPlanClip, modelId, positions, type) {
  let ps;
  if (positions && positions.length) {
    if (type == "newRoad") {
      ps = [positions[1], positions[0]];
    } else {
      ps = positions;
    }
  } else {
    return;
  }

  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    tileSetPlanClip.positions = ps;
  } else {
    // Vue.$alert("模型ID无效。", "友情提示", {
    //   confirmButtonText: "确定",
    //   type: "warning",
    //   callback: (action) => {},
    // });
    console.log("模型ID无效。");
  }
}

export function colorHide(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    const conditions = [];
    conditions.push(["true", "rgba(255, 255, 255,0)"]);
    tilesetLayer.style = new Cesium.Cesium3DTileStyle({
      color: {
        conditions: conditions,
      },
    });
  }
}
export function colorShow(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    const conditions = [];
    conditions.push(["true", "rgb(255, 255, 255,1)"]);
    tilesetLayer.style = new Cesium.Cesium3DTileStyle({
      color: {
        conditions: conditions,
      },
    });
  }
}

export function getData(x, y, z) {
  // 当前项目的proj4
  const fromProjection = `PROJCS["CGCS2000_3_Degree_GK_CM_114E",GEOGCS["GCS_China_Geodetic_Coordinate_System_2000",DATUM["D_China_2000",SPHEROID["CGCS2000",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["central_meridian",113.75],PARAMETER["false_easting",500000],PARAMETER["false_northing",0],PARAMETER["latitude_of_origin",0],PARAMETER["scale_factor",1],UNIT["metre",1]]`;

  let arr = [Number(x), Number(y), z];

  // 固定WGS84
  const toProjection = `GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],
                                  AUTHORITY["EPSG", "6326"]], PRIMEM["Greenwich", 0, AUTHORITY["EPSG", "8901"]],
                                  UNIT["degree", 0.0174532925199433, AUTHORITY["EPSG", "9122"]], AUTHORITY["EPSG", "4326"]]`;

  // proj4存在
  if (fromProjection) {
    // 转换出坐标
    const proj4List = proj4(fromProjection, toProjection, arr);
    return proj4List;
  }
}
export function arrChange(num, arr) {
  const newArr = [];
  while (arr.length > 0) {
    newArr.push(arr.splice(0, num));
  }
  return newArr;
}
export function clearWJ() {
  tileSetPlanClip_list.forEach((el) => {
    el.clear();
  });
}
